(function () {
  'use strict';
  const widget = document.querySelector('[data-pa-notify]');
  const dialog = document.getElementById('pa-notify-dialog');
  if (!widget || !dialog || typeof dialog.showModal !== 'function') return;
  const hanger = widget.querySelector('.pa-notify__hanger');
  const tab = widget.querySelector('.pa-notify__tab');
  let showTimer;
  let dockTimer;
  let opener;
  function dock() {
    clearTimeout(showTimer);
    clearTimeout(dockTimer);
    const focused = document.activeElement === hanger;
    widget.hidden = false;
    widget.classList.add('is-docked');
    hanger.hidden = true;
    tab.hidden = false;
    if (focused) tab.focus({ preventScroll: true });
  }
  function open(event) {
    opener = event ? event.currentTarget : tab;
    dock();
    if (!dialog.open) dialog.showModal();
  }
  widget.querySelectorAll('[data-pa-open]').forEach(function (button) {
    button.addEventListener('click', open);
  });
  dialog.querySelector('[data-pa-close]').addEventListener('click', function () {
    dialog.close();
  });
  dialog.addEventListener('click', function (event) {
    const rect = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
  });
  dialog.addEventListener('close', function () {
    (opener && !opener.hidden ? opener : tab).focus({ preventScroll: true });
  });
  // Keep server-rendered success and validation feedback visible after submission.
  if (dialog.querySelector('[data-pa-result]')) {
    open();
  } else {
    showTimer = setTimeout(function () {
      widget.hidden = false;
      dockTimer = setTimeout(dock, 3000);
    }, 5000);
  }
})();
